const ProviderType = Object.freeze({
  MORNINGSTAR: "MORNINGSTAR",
  ADMIN: "ADMIN",
});

export default ProviderType;
